import React from "react";
import "../../App.css";

const App: React.FC = () => {
  return (
    <>
      <h1>Terms & poclicies</h1>
      <div className="lorem-ipsum">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent id
        nisl nec lacus mattis facilisis eu in purus. Praesent dignissim dolor et
        dictum placerat. Ut iaculis tellus vitae ultricies commodo. Mauris
        cursus libero in auctor varius. Vestibulum justo nisi, posuere ut rutrum
        a, scelerisque vitae ipsum. Phasellus tempor vel magna ac rhoncus. Ut
        fermentum tellus vel leo pellentesque, vel imperdiet nisi congue. Fusce
        tortor tortor, condimentum et elit a, viverra mattis nisi. Phasellus
        nisi purus, malesuada malesuada fringilla ut, aliquet sed ligula.
        Quisque vestibulum nibh at elit facilisis tincidunt. Quisque vel lacinia
        odio. Donec posuere augue eget velit tincidunt feugiat. Donec viverra
        efficitur mi a faucibus. Phasellus et luctus leo. Nam mollis lacinia
        mauris sit amet consequat.
      </div>
      <div className="lorem-ipsum">
        Sed consectetur nunc augue, vitae aliquet orci gravida quis. Fusce
        faucibus mi velit, sit amet viverra arcu ornare id. Ut consectetur
        congue molestie. Vestibulum a est a est elementum commodo. Nulla nec
        laoreet ex. Nulla lobortis laoreet nisi, laoreet tempor enim cursus et.
        Vivamus sagittis congue lorem vel dapibus. Sed nec neque tempor,
        accumsan ante a, rutrum felis.
      </div>
      <div className="lorem-ipsum">
        Duis aliquet, enim a fermentum efficitur, metus ligula elementum tortor,
        sed facilisis augue odio vitae purus. Ut mattis lectus vitae tempor
        efficitur. Nullam non convallis mi. Vestibulum volutpat neque et
        accumsan pretium. Aliquam vehicula nulla ac pulvinar mattis. Praesent
        aliquet auctor enim, at ornare ex tristique id. In tincidunt magna eu
        purus tincidunt vestibulum. Etiam elementum nulla eget diam efficitur,
        quis congue metus porta. Mauris sit amet dui ultricies magna rhoncus
        fringilla. Aenean dapibus elit in leo tincidunt, eget tempor est
        porttitor.
      </div>
      <div className="lorem-ipsum">
        Morbi nec scelerisque nunc, et mollis leo. Vivamus ullamcorper lorem mi,
        ullamcorper pulvinar nisl aliquet ac. Aenean quis lobortis dolor.
        Curabitur nunc lectus, pellentesque ac turpis ut, hendrerit blandit mi.
        Ut blandit id massa eget imperdiet. Vivamus id risus finibus, euismod
        tortor vel, vestibulum quam. Nam rhoncus viverra erat vel pretium. In
        fringilla arcu ante, quis tincidunt sem accumsan in. Pellentesque dolor
        tortor, cursus a diam accumsan, fringilla tempor purus. Proin interdum
        sit amet felis et fermentum. Sed porttitor, purus quis faucibus posuere,
        risus felis volutpat enim, sit amet iaculis risus massa ac augue.
      </div>
      <div className="lorem-ipsum">
        Aliquam erat volutpat. Curabitur vulputate pulvinar odio, nec sagittis
        risus laoreet non. Duis in urna sed turpis ullamcorper dictum a vitae
        arcu. Phasellus ac aliquam arcu, at ultrices leo. Aliquam porttitor
        tellus eu nisi finibus posuere. Aenean mollis aliquet nisl. Praesent
        lacinia elementum ex vel imperdiet. Morbi dignissim facilisis justo quis
        venenatis. Etiam vestibulum, nisl eget venenatis ornare, turpis risus
        tincidunt lacus, non pulvinar augue ex vitae orci. Proin pharetra arcu
        sit amet erat suscipit auctor. Suspendisse sed magna eu nunc commodo
        hendrerit. Proin pretium odio in tortor sagittis sodales. Nullam
        tincidunt ipsum vel justo blandit, nec dictum nisi efficitur.
      </div>
    </>
  );
};

export default App;
